import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

import cloud1 from "../../assets/cloud_1.png";
import cloud2 from "../../assets/cloud_2.png";
import cloud3 from "../../assets/cloud_3.png";
import cloud4 from "../../assets/cloud_4.png";
import "./Clouds.scss";

const clouds = [cloud1, cloud2, cloud3, cloud4];

function Cloud({ cloud }) {

  const [width, setWidth] = useState(window.innerWidth);

  const updateWindowDimensions = () => {
    setWidth(window.innerWidth)
  }

  useEffect(() => {
    window.addEventListener('resize', updateWindowDimensions);
    return () => {
      window.removeEventListener('resize', updateWindowDimensions)
    }
  }, [])
  
  function randomInteger(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  return (
    <motion.img
      animate={{
        x: [-150, width],
      }}
      exit={{ opacity: 0 }}
      src={cloud}
      alt="cloud"
      style={{ top: randomInteger(0, 150) }}
      transition={{
        loop: Infinity,
        ease: "linear",
        duration: randomInteger(50, 90),
      }}
    ></motion.img>
  );
}

function Clouds() {
  return (
    <div className="clouds-container">
      <div className="clouds-wrapper">
        {clouds.map((cloud) => (
          <Cloud cloud={cloud} key={cloud} />
        ))}
      </div>
    </div>
  );
}

export default Clouds;
